export default __webpack_public_path__ + "static/media/treatment_top.dbe412a2.png";